module.exports = {
	"author": "Cloudinary <info@cloudinary.com>",
	"name": "cloudinary",
	"description": "Cloudinary NPM for node.js integration",
	"version": "1.9.0",
	"homepage": "http://cloudinary.com",
	"license": "MIT",
	"repository": {
		"type": "git",
		"url": "https://github.com/cloudinary/cloudinary_npm.git"
	},
	"main": "cloudinary.js",
	"dependencies": {
		"q": "1.4.x",
		"lodash": "3.10.x"
	},
	"devDependencies": {
		"coffee-script": "^1.10.0",
		"dotenv": "1.x",
		"expect.js": "0.3.x",
		"jsdom": "^9.5.0",
		"jsdom-global": "^2.1.0",
		"mocha": "2.3.x",
		"sinon": "^1.17.2"
	},
	"scripts": {
		"pretest": "npm run compile",
		"prepublish": "npm run compile",
		"test": "node_modules/.bin/mocha -R spec --recursive test/",
		"compile": "node_modules/.bin/coffee --map -o lib -c src",
		"watch": "node_modules/.bin/coffee --watch --map -o lib -c src"
	},
	"optionalDependencies": {},
	"engines": {
		"node": ">=0.6"
	},
	"browserify": {
		"transform": [
			"coffeeify"
		]
	}
};


//////////////////
// WEBPACK FOOTER
// ./~/cloudinary/package.json
// module id = 336
// module chunks = 0